import React from 'react';
import { motion } from 'framer-motion';

export default function ContactSection({ contact }) {
  return (
    <section className="contact" id="contact">
      <motion.h2 initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        Contact
      </motion.h2>

      <div className="contact-grid">
        <motion.div
          className="contact-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="contact-label">Name</div>
          <div className="contact-value">{contact.name}</div>
          <div className="contact-label">Location</div>
          <div className="contact-value">{contact.location}</div>
        </motion.div>

        <motion.div
          className="contact-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <div className="contact-label">Contact</div>
          <a className="contact-link" href={`mailto:${contact.email}`}>
            {contact.email}
          </a>
          <div className="contact-actions">
            <a className="contact-button" href={contact.whatsappUrl} target="_blank" rel="noreferrer">
              WhatsApp
            </a>
            <a className="contact-button" href={contact.facebookUrl} target="_blank" rel="noreferrer">
              Facebook
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

